
import React from 'react';
import { NavLink } from 'react-router-dom';

import Expandable from 'components/global/application/Expandable';

import slugify from 'slugify';
import './AccessoryDropMenu.sass';

interface Props {
    types: any;
    collections: any;
    showing: boolean;    // used to toggle display and switch content; component only displays with truthy values
    mouseHovered(event: React.MouseEvent<any>): void;   // methods to update parent so it knows when its safe to clear hoveredItem
    mouseUnHovered(event: React.MouseEvent<any>): void; // ^-- same
}

const AccessoryDropMenu: React.StatelessComponent<Props> = (props: Props) => {
    if (props.types) {
        return (
            <Expandable
                direction="vertical"
                maxHeight="22em"
                expanded={props.showing}
                onMouseEnter={props.mouseHovered}
                onMouseLeave={props.mouseUnHovered}
                id="submenu"
                className="AboutDropMenu-container"
            >
                <div className="Padding-container">
                    <div className="Dropmenu-column">
                        {props.types ? props.types.map((type: any, i: number) => {
                            return (
                                <span key={i} className="Category-header" >
                                    <NavLink exact to={'/accessories/type/' + slugify(type)}>
                                        {type}
                                    </NavLink>
                                </span>
                            );
                        }) : null}
                    </div>
                </div>
            </Expandable>
        );
    }

    return null;
};

export default AccessoryDropMenu;



// WEBPACK FOOTER //
// ./src/components/global/application/nav/AccessoryDropMenu.tsx